var city = {
  citycode: "021",
  adcode: "310000",
  name: "上海市",
  center: {
    lng: 121.473667,
    lat: 31.230525
  },
  districtList: [
    {
      citycode: "021",
      adcode: "310100",
      name: "上海城区",
      center: {
        lng: 121.472644,
        lat: 31.231706
      },
      districtList: [
        {
          citycode: "021",
          adcode: "310151",
          name: "崇明区",
          center: {
            lng: 121.397662,
            lat: 31.623863
          }
        },
        {
          citycode: "021",
          adcode: "310115",
          name: "浦东新区",
          center: {
            lng: 121.544346,
            lat: 31.221461
          }
        },
        {
          citycode: "021",
          adcode: "310116",
          name: "金山区",
          center: {
            lng: 121.341774,
            lat: 30.742769
          }
        },
        {
          citycode: "021",
          adcode: "310101",
          name: "黄浦区",
          center: {
            lng: 121.48442,
            lat: 31.231661
          }
        },
        {
          citycode: "021",
          adcode: "310110",
          name: "杨浦区",
          center: {
            lng: 121.525409,
            lat: 31.259588
          }
        },
        {
          citycode: "021",
          adcode: "310109",
          name: "虹口区",
          center: {
            lng: 121.504994,
            lat: 31.264917
          }
        },
        {
          citycode: "021",
          adcode: "310104",
          name: "徐汇区",
          center: {
            lng: 121.436307,
            lat: 31.188334
          }
        },
        {
          citycode: "021",
          adcode: "310106",
          name: "静安区",
          center: {
            lng: 121.447348,
            lat: 31.227718
          }
        },
        {
          citycode: "021",
          adcode: "310114",
          name: "嘉定区",
          center: {
            lng: 121.265276,
            lat: 31.375566
          }
        },
        {
          citycode: "021",
          adcode: "310117",
          name: "松江区",
          center: {
            lng: 121.227676,
            lat: 31.03257
          }
        },
        {
          citycode: "021",
          adcode: "310105",
          name: "长宁区",
          center: {
            lng: 121.424751,
            lat: 31.220537
          }
        },
        {
          citycode: "021",
          adcode: "310120",
          name: "奉贤区",
          center: {
            lng: 121.473945,
            lat: 30.918406
          }
        },
        {
          citycode: "021",
          adcode: "310118",
          name: "青浦区",
          center: {
            lng: 121.124249,
            lat: 31.15098
          }
        },
        {
          citycode: "021",
          adcode: "310112",
          name: "闵行区",
          center: {
            lng: 121.380857,
            lat: 31.112834
          }
        },
        {
          citycode: "021",
          adcode: "310113",
          name: "宝山区",
          center: {
            lng: 121.489431,
            lat: 31.405242
          }
        },
        {
          citycode: "021",
          adcode: "310107",
          name: "普陀区",
          center: {
            lng: 121.39547,
            lat: 31.249618
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/shanghai.js